import { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

export default function EnergyPanel({ game, refresh, compact = false }) {
  const en = game.energy;
  const [left, setLeft] = useState(en.next_in);
  const [busy, setBusy] = useState(null);
  useEffect(() => setLeft(en.next_in), [en.next_in, en.value]);
  useEffect(() => {
    if (!left) return;
    const t = setInterval(() => setLeft((x) => {
      if (x <= 1) { refresh(); return 0; }
      return x - 1;
    }), 1000);
    return () => clearInterval(t);
  }, [left > 0, refresh]); // eslint-disable-line react-hooks/exhaustive-deps

  const buy = async (pack) => {
    setBusy(pack);
    try { await api.post("/game/energy/buy", { pack }); await refresh(); toast.success("Energy restored"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  const free = async () => {
    setBusy("free");
    try { await api.post("/game/energy/free"); await refresh(); toast.success("Free refill used. Energy restored"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  const full = en.value >= en.max;

  return (
    <div data-testid="energy-panel" className="rounded-xl border border-cyan-500/30 bg-cyan-950/20 p-3">
      <div className="flex items-center justify-between mb-2">
        <span className="flex items-center gap-1.5 text-sm font-semibold text-cyan-200"><Zap className="w-4 h-4" />Energy</span>
        <span className="font-mono-game text-sm" data-testid="energy-value">{en.value}/{en.max}</span>
      </div>
      <div className="h-2 rounded-full bg-slate-900 overflow-hidden mb-2">
        <div className="h-full bg-gradient-to-r from-cyan-400 to-blue-500 transition-[width] duration-500" style={{ width: `${(en.value / en.max) * 100}%` }} />
      </div>
      <p className="text-[11px] text-slate-400" data-testid="energy-timer">
        {full ? "Full. Every fight and event costs 1." : `+1 in ${fmt(left)} · regenerates 1 every ${en.regen_minutes} min`}
      </p>
      {!compact && !full && (
        en.free_refill_ready ? (
          <button data-testid="energy-free-refill" disabled={!!busy} onClick={free} className="w-full mt-3 py-2 rounded-lg border border-emerald-400/60 bg-emerald-500/10 text-emerald-200 text-xs nft-glow hover:bg-emerald-500/20 disabled:opacity-40">Free daily refill · 1/1 holder perk</button>
        ) :
        <button data-testid="energy-buy-full" disabled={!!busy || game.user.credits < en.packs.full.price} onClick={() => buy("full")} className="w-full mt-3 py-2 rounded-lg ember-btn text-xs disabled:opacity-40">Restore full energy · {en.packs.full.price.toLocaleString()} credits</button>
      )}
      {!compact && <p className="text-[10px] text-amber-300/80 mt-2" data-testid="energy-perk-note">{en.regen_minutes < 30 ? "Exclusive holder perk: energy refills twice as fast." : "Each NFT collection adds +5 max energy. Exclusive holders refill twice as fast."}</p>}
    </div>
  );
}
